export default __webpack_public_path__ + "static/media/exit.dbcc4bd3.svg";